if (!customElements.get('pdp-faq')) {
  class PdpFaq extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-faq-answer]').forEach((answer) => {
        answer.style.height = '0px';
        answer.style.overflow = 'hidden';
      });

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-faq-trigger]');
        if (!trigger) return;
        this._toggle(trigger);
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const trigger = event.target.closest('[data-faq-trigger]');
        if (!trigger) return;
        event.preventDefault();
        this._toggle(trigger);
      });
    }

    _toggle(trigger) {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const answerId = trigger.getAttribute('aria-controls');
      const answer = this.querySelector(`#${answerId}`);
      if (!answer) return;

      trigger.setAttribute('aria-expanded', String(!expanded));

      if (expanded) {
        answer.style.height = answer.scrollHeight + 'px';
        answer.offsetHeight;
        answer.style.height = '0px';
      } else {
        const target = answer.scrollHeight;
        answer.style.height = '0px';
        answer.offsetHeight;
        answer.style.height = target + 'px';
        answer.addEventListener(
          'transitionend',
          () => { answer.style.height = 'auto'; },
          { once: true }
        );
      }
    }
  }

  customElements.define('pdp-faq', PdpFaq);
}
